<!-- @format -->

<template>
	<transition name="modal-fade">
		<div>
			<div class="modal-backdrop">
				<div
					class="modal"
					role="dialog"
					aria-labelledby="modalTitle"
					aria-describedby="modalDescription"
				>
					<header class="modal-header" id="modalTitle">
						<slot name="header"></slot>
					</header>

					<section class="modal-body" id="modalDescription">
						<b-button
							type="button"
							class="is-danger"
							@click="onCloseModal"
							aria-label="Close modal"
						>
							X Close
						</b-button>
						<slot name="body"></slot>
						<div style="margin-top: 30px">
							<p>
								<span class="tag-style">Invoice Number: </span
								>{{ invoiceData.invoiceNumber }}
							</p>
							<p>
								<span class="tag-style">Customer: </span
								>{{ invoiceData.customer }}
							</p>
							<p>
								<span class="tag-style">Invoice Date: </span
								>{{ invoiceData.invoiceDate }}
							</p>
							<p>
								<span class="tag-style">Invoice Due Date: </span
								>{{ invoiceData.dueDate }}
							</p>
						</div>
						<div>
							<b-field class="margin-top-20" label="Select new due date">
								<b-datepicker
									v-model="selectedDueDate"
									:show-week-number="showWeekNumber"
									:locale="locale"
									placeholder="Click to select..."
									icon="calendar-today"
									trap-focus
								>
								</b-datepicker>
							</b-field>
						</div>
						<div>
							<b-button
								class="is-success"
								style="margin-top: 30px"
								@click="changeDueDate"
							>
								Change Due Date
							</b-button>
						</div>
					</section>
					<footer class="modal-footer">
						<slot name="footer"></slot>
					</footer>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import useChangeInvoiceDueDateStore from '@/_srcv2/pages/admin/super-privileges/change-invoice-due-date/useChangeInvoiceDueDateStore.js'
import { onMounted, reactive } from '@vue/composition-api'
import ChangeInvoiceDueDateMutation from '@/_srcv2/pages/admin/super-privileges/change-invoice-due-date/ChangeInvoiceDueDateMutation.graphql'
import { useMutation } from '@vue/apollo-composable'
// import Router from '@/router'
import Store from '@/store'
import { ref, watchEffect } from '@vue/composition-api'
import dateformat from 'dateformat'

export default {
	name: 'ModalInvoiceFrame',
	props: {
		data: {
			type: Object,
			required: true,
		},
		handler: {
			type: Function,
		},
	},
	setup(props) {
		const invoiceData = props.data
		const today = ref(new Date())
		const showWeekNumber = false
		const locale = 'sv-SE'
		const selectedDueDate = ref(new Date(props.data.dueDate))
		watchEffect(() => {
			mutationVariables.invoice_due_date = dateformat(
				selectedDueDate.value,
				'yyyy-mm-dd',
			)
			console.log('mutationVariables', mutationVariables)
			console.log('selectedDueDate', selectedDueDate.value)
		})
		const { isPopupVisible } = useChangeInvoiceDueDateStore()
		const onCloseModal = () => {
			isPopupVisible.value = false
			props.handler()
			// Router.push({ name: 'ChangeInvoiceDueDate' })
		}
		const mutationVariables = reactive({
			our_company: Store.getters.getUserCurrentCompany,
			invoice_number: props.data.invoiceNumber,
			invoice_due_date: props.data.dueDate,
		})
		const {
			mutate: changeInvoiceDueDate,
			onError,
			onDone,
		} = useMutation(ChangeInvoiceDueDateMutation, () => ({
			variables: mutationVariables,
		}))
		const changeDueDate = () => {
			changeInvoiceDueDate()
		}
		onError((err) => alert('Error: ', err))
		onDone(() => onCloseModal())
		// --------------------------------------------------------------------------------
		onMounted(() => {})
		// ---------------------------------------------------------------------------
		return {
			onCloseModal,
			isPopupVisible,
			invoiceData,
			changeDueDate,
			selectedDueDate,
			today,
			showWeekNumber,
			locale,
		}
	},
}
</script>

<style scoped>
.modal-backdrop {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.9);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 100000000001;
}
.modal {
	background: #ffffff;
	box-shadow: 2px 2px 20px 1px;
	overflow-x: auto;
	display: flex;
	flex-direction: column;
	max-width: 780px;
	max-height: 100%;
	height: 100%;
	margin: auto;
	padding: 20px;
	opacity: 1;
}
.modal-header,
.modal-footer {
	padding: 15px;
	display: flex;
}
.modal-header {
	position: relative;
	color: #4aae9b;
	justify-content: space-between;
}
.modal-footer {
	flex-direction: column;
	justify-content: flex-end;
}
.modal-body {
	position: relative;
	padding: 20px 10px;
}
.modal-fade-enter,
.modal-fade-leave-to {
	opacity: 0;
}
.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.5s ease;
}
.tag-style {
	font-weight: 700;
	color: blue;
}
p {
	margin-bottom: 10px;
}
</style>
